import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CardTitle, Collapsible, getTestId, isFirstItem, isLastItem } from '@airtel/air-design-system';
import { useState } from 'react';
import { getComparisonTableWidgetV2ComponentStyles } from './ComparisonTableWidgetV2ComponentStyles';
import CompareBenefitListV2 from './components/compare-benefit-list-v2/CompareBenefitListV2';
export var ComparisonTableWidgetV2Component = props => {
  var tableListData = props.tableListData,
    style = props.style,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'ComparisonTableWidgetV2Component' : _props$testID,
    isCollapsible = props.isCollapsible,
    disableToggle = props.disableToggle,
    initialOpen = props.initialOpen,
    _props$showIcon = props.showIcon,
    showIcon = _props$showIcon === void 0 ? true : _props$showIcon,
    collapsibleTitle = props.collapsibleTitle,
    collapsibleSubTitle = props.collapsibleSubTitle,
    multiTableListData = props.multiTableListData,
    _props$isFirstTable = props.isFirstTable,
    isFirstTable = _props$isFirstTable === void 0 ? true : _props$isFirstTable,
    _props$isLastTable = props.isLastTable,
    isLastTable = _props$isLastTable === void 0 ? true : _props$isLastTable,
    onUserAction = props.onUserAction;
  var comparisonTableWidgetV2ComponentStyles = getComparisonTableWidgetV2ComponentStyles();
  var _useState = useState(initialOpen),
    isExpanded = _useState[0],
    setIsExpanded = _useState[1];
  var onCollapsibleToggleHandler = state => {
    setIsExpanded(state);
  };
  if (multiTableListData) {
    return _jsx(_Fragment, {
      children: multiTableListData === null || multiTableListData === void 0 ? void 0 : multiTableListData.map((tabledata, idx) => {
        return _jsx(ComparisonTableWidgetV2Component, Object.assign({}, getTestId(testID), tabledata, {
          index: idx,
          isFirstTable: isFirstItem(idx),
          isLastTable: isLastItem(multiTableListData, idx),
          onUserAction: onUserAction
        }), idx);
      })
    });
  }
  if (isCollapsible) {
    return _jsx(Collapsible, Object.assign({
      childNoVerticalPadding: true,
      childNoHorizontalPadding: true,
      titleComponent: collapsibleTitle && _jsx(CardTitle, Object.assign({
        title: collapsibleTitle,
        subTitle: collapsibleSubTitle
      }, getTestId(testID, 'cardTitle'))),
      showIcon: showIcon,
      disabled: disableToggle,
      initialOpen: initialOpen,
      onToggleHandler: onCollapsibleToggleHandler
    }, getTestId(testID), {
      style: [comparisonTableWidgetV2ComponentStyles.collapsibleContainer, !isExpanded && isLastTable ? comparisonTableWidgetV2ComponentStyles === null || comparisonTableWidgetV2ComponentStyles === void 0 ? void 0 : comparisonTableWidgetV2ComponentStyles.collapsibleTitleLastItem : !isExpanded ? comparisonTableWidgetV2ComponentStyles.collapsibleBorder : {}, style]
    }, {
      children: _jsx(CompareBenefitListV2, Object.assign({}, getTestId(testID), {
        tableListData: tableListData,
        isFirstTable: isFirstTable,
        isLastTable: isLastTable,
        onUserAction: onUserAction
      }))
    }));
  } else {
    return _jsx(CompareBenefitListV2, Object.assign({
      isFirstTable: isFirstTable,
      isLastTable: isLastTable
    }, getTestId(testID), {
      tableListData: tableListData,
      onUserAction: onUserAction
    }));
  }
};